const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        redirectURI: '',
        secret: '',
        active: false
    },

    getSecret: function() {
        return this.get('secret');
    },

    getRedirectURI: function() {
        return this.get('redirectURI');
    },

    getActive: function() {
        return this.get('active');
    }
});



// WEBPACK FOOTER //
// ./jiji/domain/entity/oauth/client.js